import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ACTIONS } from 'components/CallToAction';
import * as actions from 'components/CallToAction/actions';
import { CMS_ACTION_TYPES } from './constants';

export class CmsAction extends PureComponent {
  addActionProps(action, value) {
    const mapActionsToProps = {
      [ACTIONS.LINK]: { to: value },
      [ACTIONS.OFFER_CHECKOUT]: { promotionAlias: value },
      [ACTIONS.SHOW_MODAL]: {
        modalName: 'YouTubeVideoModal',
        modalProps: { videoId: value },
      },
    };
    return mapActionsToProps[action];
  }

  renderAction(mappedAction, props = this.props) {
    const { actionValue, children, ...extraProps } = props;

    const Component = actions[mappedAction];

    if (!Component || !children) {
      return null;
    }

    return (
      <Component {...extraProps} {...this.addActionProps(mappedAction, actionValue)}>
        {children}
      </Component>
    );
  }

  render() {
    switch (this.props.actionType) {
      case CMS_ACTION_TYPES.OFFER_CHECKOUT:
        return this.renderAction(ACTIONS.OFFER_CHECKOUT);
      case CMS_ACTION_TYPES.RAF:
        return this.renderAction(ACTIONS.SHOW_FRIENDBUY_WIDGET);
      case CMS_ACTION_TYPES.YOUTUBE_VIDEO:
        return this.renderAction(ACTIONS.SHOW_MODAL);
      case CMS_ACTION_TYPES.URL:
        return this.renderAction(ACTIONS.LINK);
      default:
        return null;
    }
  }
}

CmsAction.propTypes = {
  actionType: PropTypes.string.isRequired,
  actionValue: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
};
